"use strict";
/**
 *
 * useForceUpdate
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useForceUpdate() {
    const [, setCounter] = react_1.useState(0);
    const forceUpdate = react_1.useCallback(() => setCounter((counter) => counter + 1), []);
    return forceUpdate;
}
exports.useForceUpdate = useForceUpdate;
